<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <div class="col-md-12">
        <Header
          pageTitle="Create New Banking Office"
          class="card-container"
        ></Header>
        <div class="row">
          <div class="col-md-3">
            <label>Country</label>
            <v-select
              data-vv-as="Country"
              :class="errors.has('CountryDropdown') ? 'has-danger' : 'no'"
              :error="getError('CountryDropdown')"
              v-validate="'required'"
              v-model="bankingOffice['countryId']"
              name="CountryDropdown"
              :reduce="(item) => item.countryId"
              label="name"
              :options="countriesOptions"
              placeholder="Please select a country."
            />
            <span v-show="errors.has('CountryDropdown')" class="error">
              {{ errors.first("CountryDropdown") }}</span
            >
          </div>
          <div class="col-md-3">
            <label>Bank Name</label>
            <base-input
              data-vv-as="Bank Name"
              v-validate="'required'"
              v-model="bankingOffice['bankName']"
              name="bankName"
              placeholder="Please enter bank name."
              :error="getError('bankName')"
            />
          </div>
          <div class="col-md-3">
            <label>Bank Address</label>
            <base-input
              data-vv-as="Bank Address"
              v-validate="'required'"
              v-model="bankingOffice['bankAddress']"
              name="bankAddress"
              placeholder="Please enter bank address."
              :error="getError('bankAddress')"
            />
          </div>
          <div class="col-md-3">
            <label>Account Name/Number</label>
            <base-input
              data-vv-as="Account Name/Number"
              v-validate="'required'"
              v-model="bankingOffice['accountName']"
              name="accountNumber"
              placeholder="Please enter bank account number."
              :error="getError('accountNumber')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 offset-md-3">
            <label>International Bank Account Number (IBAN)</label>
            <base-input
              data-vv-as="International Bank Account Number (IBAN)"
              v-model="bankingOffice['IBAN']"
              name="bankIBAN"
              placeholder="Please enter International Bank Account Number (IBAN)."
            />
          </div>
          <div class="col-md-3">
            <label>SWIFT / ABA</label>
            <base-input
              data-vv-as="SWIFT / ABA"
              v-model="bankingOffice['SWIFT']"
              name="bankSWIFT"
              placeholder="Please enter SWIFT / ABA."
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-2 align-left">
            <base-button
              @click="returnToEditBankingOfficesDashboard()"
              class="btn btn-dark"
              v-b-popover.hover.bottom="
                'Navigate back to edit banking offices dashboard.'
              "
            >
              <i class="tim-icons icon-double-left"></i> Back
            </base-button>
          </div>
          <div class="col-md-2 offset-md-3 align-left">
            <base-button
              @click="addBankingOffice()"
              type="primary"
              v-b-popover.hover.bottom="'Save changes.'"
            >
              <i class="tim-icons icon-bank"></i> Add Banking Office
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </center>
</template>

<script>
import Header from "@/components/App/Header.vue";
import axios from "@/axios";
import Util from "@/util/util";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AdminCreateBankingOffice",
  components: {
    Header,
  },
  data() {
    return {
      bankingOffice: {
        countryId: "",
        bankName: "",
        bankAddress: "",
        SWIFT: "",
        IBAN: "",
        accountName: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      countriesOptions: "countries/allCountries",
    }),
  },
  mounted() {
    this.getAllCountries();
    this.errors.clear();
  },
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries",
    }),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    returnToEditBankingOfficesDashboard() {
      this.$router.push("/Admin/BankingOffices");
    },
    async addBankingOffice() {
      let ctx = this;
    await this.$validator.validateAll().then(async (result) => {
      if (result) {
        await axios
          .post("api/adminbankingoffice", this.bankingOffice)
          .then((response) => {
            this.$router.push("/Admin/BankingOffices");
          })
      }else{
       const errors =  this.errors.all()
        this.$toast.error( errors.length > 1 ? 'Please complete required fields': errors[0]); 
      }
      });
    },
  },
};
</script>

<style></style>
